import auth0 from 'auth0-js'

import CONFIG from '../config'
import { setAuthToken } from './api'

const l = window.location
const domainUrl = `${l.protocol}//${l.host}`

const options = {
  domain: CONFIG.auth0.domain,
  // audience: `https://${CONFIG.auth0.domain}/userinfo`,
  clientID: CONFIG.auth0.clientId,
  // At some point we want to redirect to the location where you are from, but for now, don't worry about it
  // redirectUrl: `${l.protocol}//${l.host}/callback?${encodeURIComponent(l.pathname)}`,
  redirectUri: `${domainUrl}/callback`,
  responseType: 'token id_token',
  scope: 'openid',
}

const webAuth = new auth0.WebAuth(options)
export default webAuth

export function login(email, password, errorHandler) {
  webAuth.login({
    email,
    password,
    realm: CONFIG.auth0.connection,
  }, errorHandler)
}

export function logout() {
  webAuth.logout({ returnTo: `${domainUrl}`, clientID: CONFIG.auth0.clientId })
}

export function resetPassword(email, errorHandler) {
  const authParams = {
    state: 'blokable',
  }
  webAuth.passwordlessStart({
    email, send: 'link', connection: 'email', authParams, redirectUri: `${domainUrl}/magiclink`,
  }, errorHandler)
}

export function getErrorText(err) {
  const error = err || {}
  return error.description
    || error.errorDescription
    || 'An error has occurred. Please contact your BlokSense Administrator.'
}

export function setSession(authResult) {
  setAuthToken(authResult.idToken)
}

export function removeSession() {
  setAuthToken()
}

export function isAuthenticated(auth) {
  if (!auth) {
    return false
  }
  if (!auth.isAuthenticated) {
    return false
  }
  if (!auth.accessToken) {
    return false
  }
  if (!auth.idToken) {
    return false
  }
  // Check whether the current time is past the
  // access token's expiry time
  return Date.now() < auth.expiresAt
}

export function isAdmin(auth) {
  return isAuthenticated(auth) && auth.admin
}

function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).replace(/(.)/g, (m, p) => {
    const code = p.charCodeAt(0).toString(16).toUpperCase()
    return code.length < 2 ? `%0${code}` : `%${code}`
  }))
}

function parseJWT(token) {
  if (!token) return {}
  const base64Url = token.split('.')[1]
  if (!base64Url) return {}
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  return JSON.parse(b64DecodeUnicode(base64))
}

export function userID(auth) {
  let id = 'anonymous'
  if (isAuthenticated(auth)) {
    const parsed = parseJWT(auth.idToken)
    if (parsed && parsed.sub) {
      id = parsed.sub
    }
  }
  return id
}

export function parsedAuth(auth) {
  const { idToken, ...rest } = auth
  return { ...rest, ...parseJWT(idToken) }
}

export function requireSetup(authResult) {
  const metadata = authResult.idTokenPayload['https://blokable.com'] || {}
  return Boolean(metadata.require_setup)
}
